export const KEY_ENTER = 13;
export const KEY_ESCAPE = 27;
